export class RestoreGoogleWorkspaceUserDriveByEntityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "GoogleWorkspaceUserDriveRestoreScope",
            "format": ""
        },
        {
            "name": "entireDrive",
            "baseName": "entireDrive",
            "type": "GoogleWorkspaceUserDriveEntireDriveOptions",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "GoogleWorkspaceUserDriveSelectedItemsOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceUserDriveByEntityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
